import React from 'react';
import type { LayoutContext, SidebarSection } from './layout-context';
import { layoutContext } from './layout-context';
import { useBreakpoint } from '@/hooks/use-breakpoint';

/**
 * @deprecated
 * @param children
 * @constructor
 */
export const LayoutProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { isMd: isDesktop } = useBreakpoint('md');
  const [openedTableInSidebar, setOpenedTableInSidebar] = React.useState<
    string | undefined
  >();
  const [openedRelationshipInSidebar, setOpenedRelationshipInSidebar] =
    React.useState<string | undefined>();
  const [openedDependencyInSidebar, setOpenedDependencyInSidebar] =
    React.useState<string | undefined>();
  const [selectedSidebarSection, setSelectedSidebarSection] =
    React.useState<SidebarSection>('tables');
  const [isSidePanelShowed, setIsSidePanelShowed] =
    React.useState<boolean>(isDesktop);
  const [isSelectSchemaOpen, setIsSelectSchemaOpen] =
    React.useState<boolean>(false);

  const closeAllTablesInSidebar: LayoutContext['closeAllTablesInSidebar'] =
    () => setOpenedTableInSidebar('');

  const closeAllRelationshipsInSidebar: LayoutContext['closeAllRelationshipsInSidebar'] =
    () => setOpenedRelationshipInSidebar('');

  const closeAllDependenciesInSidebar: LayoutContext['closeAllDependenciesInSidebar'] =
    () => setOpenedDependencyInSidebar('');

  const hideSidePanel: LayoutContext['hideSidePanel'] = () =>
    setIsSidePanelShowed(false);

  const showSidePanel: LayoutContext['showSidePanel'] = () =>
    setIsSidePanelShowed(true);

  const toggleSidePanel: LayoutContext['toggleSidePanel'] = () => {
    setIsSidePanelShowed((prevIsSidePanelShowed) => !prevIsSidePanelShowed);
  };

  const openTableFromSidebar: LayoutContext['openTableFromSidebar'] = (
    tableId
  ) => {
    showSidePanel();
    setSelectedSidebarSection('tables');
    setOpenedTableInSidebar(tableId);
  };

  const openRelationshipFromSidebar: LayoutContext['openRelationshipFromSidebar'] =
    (relationshipId) => {
      showSidePanel();
      setSelectedSidebarSection('relationships');
      setOpenedRelationshipInSidebar(relationshipId);
    };

  const openDependencyFromSidebar: LayoutContext['openDependencyFromSidebar'] =
    (dependencyId) => {
      showSidePanel();
      setSelectedSidebarSection('dependencies');
      setOpenedDependencyInSidebar(dependencyId);
    };

  const openSelectSchema: LayoutContext['openSelectSchema'] = () =>
    setIsSelectSchemaOpen(true);

  const closeSelectSchema: LayoutContext['closeSelectSchema'] = () =>
    setIsSelectSchemaOpen(false);
  return (
    <layoutContext.Provider
      value={{
        openedTableInSidebar,
        selectedSidebarSection,
        openTableFromSidebar,
        selectSidebarSection: setSelectedSidebarSection,
        openedRelationshipInSidebar,
        openRelationshipFromSidebar,
        closeAllTablesInSidebar,
        closeAllRelationshipsInSidebar,
        isSidePanelShowed,
        hideSidePanel,
        showSidePanel,
        toggleSidePanel,
        isSelectSchemaOpen,
        openSelectSchema,
        closeSelectSchema,
        openedDependencyInSidebar,
        openDependencyFromSidebar,
        closeAllDependenciesInSidebar,
      }}
    >
      {children}
    </layoutContext.Provider>
  );
};
